import { Calendar, Divider, Form, FormInstance, Row } from "antd";
import { CalendarHeader } from "./CalendarHeader";
import { useCallback } from "react";
import dayjs, { Dayjs } from "dayjs";
import { ButtonGroup } from "./ButtonGroup";
import { RecurrentSettings } from "./ReccurentSettings";
import { useSetInitialData } from "../hooks/useSetInitialData";
import { useSelector } from "react-redux";
import { ScheduleEmailOptions } from "..";

type FormContainerProps = {
  initialData: any;
  toggleOpen: (value: boolean) => void;
  onSchedule: (values: any) => void;
  setOpen: React.Dispatch<React.SetStateAction<boolean>>;
  options?: ScheduleEmailOptions;
};

export const CalendarContainer = ({ initialData, toggleOpen, onSchedule, setOpen, options }: FormContainerProps) => {
  const [form]: FormInstance[] = Form.useForm();

  const metaData = useSelector((state: any) => state.metaData);

  const LABEL_FORMAT = "MMM DD, YYYY";

  const displayTime = Form.useWatch("scheduledDate", form);

  const { initialValues } = useSetInitialData(initialData);

  const close = useCallback(() => toggleOpen(false), [toggleOpen]);

  const onChange = useCallback(
    (val: Dayjs) => {
      const year = val.get("year") + 5;

      form.setFieldValue("endDate", val.year(year));
    },
    [form]
  );

  return (
    <Form form={form} initialValues={initialValues} className="schedule-email-form">
      <Row className="d-block mb-4">
        <Form.Item label="" name="scheduledDate" className="mb-0">
          <Calendar
            onChange={onChange}
            fullscreen={false}
            headerRender={({ onChange, value }) => <CalendarHeader onChange={onChange} value={value} />}
          />
        </Form.Item>
        <Divider className="my-0" />
        <Row className="pt-6">
          <span className="elipsis" title={metaData.windowsTimeZoneId}>
            {dayjs(displayTime).format(LABEL_FORMAT)}, 8AM ({metaData.windowsTimeZoneId})
          </span>
        </Row>
        <RecurrentSettings form={form} initialData={initialData} options={options} />
      </Row>
      <ButtonGroup form={form} close={close} onSchedule={onSchedule} setOpen={setOpen} />
    </Form>
  );
};
